import dayjs from 'dayjs';
import { DATE_FORMAT_API } from './constants';

export function dateFormatForAPI(date) {
	if (!date) {
		return '';
	}
	return dayjs(date).format(DATE_FORMAT_API);
}
